import { render, staticRenderFns } from "./BulkActions.vue?vue&type=template&id=2af7675c"
import script from "./BulkActions.vue?vue&type=script&lang=js"
export * from "./BulkActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports